import {
  compose, withStateHandlers, lifecycle,
} from 'recompose';

import TabWrapper from './tabWrapper';

const changeStatusTab = ({ statusTab }) => val => ({ statusTab: val || !statusTab });

const enhance = compose(
  withStateHandlers(({ defaultStatusTab }) => ({ statusTab: defaultStatusTab }), {
    changeStatusTabStateHandler: changeStatusTab,
  }),
  lifecycle({
    componentDidUpdate(prevState) {
      const { statusTab: prevStatusTab } = prevState;
      const { statusTab, onChangeStatusTab } = this.props;
      if (onChangeStatusTab && prevStatusTab !== statusTab) {
        onChangeStatusTab(statusTab);
      }
    },
  }),
);

export default enhance(TabWrapper);
